// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyCSMMRCX0kq83EDeDhsi8rqGhoXYxZTFlw",
    authDomain: "qr-bwp.firebaseapp.com",
    projectId: "qr-bwp",
    storageBucket: "qr-bwp.firebasestorage.app",
    messagingSenderId: "554348449739",
    appId: "1:554348449739:web:220bd768f1e33d9170704e",
    measurementId: "G-62QZRD92RX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };